import { getContentTypeById } from "@transfr-inc/dashboard-components/curriculum";
import { formatDateDigits } from "@transfr-inc/dashboard-components/utils";
import { formatTimeToHHMMSS } from "./date.utils";

const getContentTypeLabel = (contentType) => {
  try {
    return getContentTypeById(contentType).label || "";
  } catch (e) {
    console.warn("Error getting content type label:", e);
    return contentType || "";
  }
};

const formatScore = (masteryScore) => {
  if (!masteryScore || masteryScore === "") return "";
  const scoreValue =
    typeof masteryScore === "number" ? masteryScore : parseFloat(masteryScore);
  return !isNaN(scoreValue) ? `${Math.round(scoreValue * 100)}%` : "";
};

const formatAttempts = (totalAttempts) => {
  if (!totalAttempts || totalAttempts === "") return "";
  const attemptValue =
    typeof totalAttempts === "number" ? totalAttempts : parseInt(totalAttempts);
  return !isNaN(attemptValue) && attemptValue > 0 ? attemptValue : "";
};

const getActivityStatus = (userActivityData) => {
  if (userActivityData.exempt) return "Exempt";
  if (userActivityData.isComplete) return "Complete";
  if (userActivityData.simCompletionDate) return "In Progress";
  return "Not Started";
};

const createCSVRow = (user, activity, userActivityData, programName) => ({
  Program: programName || "",
  Unit: activity.unitTitle || "",
  Lesson: activity.lessonTitle || "",
  Activity: activity.title || "",
  "Activity Type": getContentTypeLabel(activity.contentType),
  "Last Name": user.lastName || "",
  "First Name": user.firstName || "",
  Username: user.username || "",
  Time: formatTimeToHHMMSS(userActivityData.timeSpent),
  Status: getActivityStatus(userActivityData),
  Score: formatScore(userActivityData.masteryScore),
  Attempts: formatAttempts(userActivityData.totalAttempts),
  "Last Attempted": userActivityData.simCompletionDate
    ? formatDateDigits(userActivityData.simCompletionDate)
    : "",
  Complete: userActivityData.isComplete ? "Yes" : "No",
});

const createTraineeCSVRow = (activity, programName) => ({
  Program: programName || "",
  Unit: activity.unitTitle || "",
  Lesson: activity.lessonTitle || "",
  Activity: activity.title || "",
  "Activity Type": getContentTypeLabel(activity.contentType),
  Time: formatTimeToHHMMSS(activity.timeSpent),
  Status: activity.masteryStatus,
  Score: formatScore(activity.masteryScore),
  Attempts: formatAttempts(activity.totalAttempts),
  "Last Attempted": activity.completionDate
    ? formatDateDigits(activity.completionDate)
    : "",
  Complete: activity.completed ? "Yes" : "No",
});

export const generateGradebookCSVData = (users, activities, programName) => {
  const csvData = [];

  users.forEach((user) => {
    activities.forEach((activity) => {
      const userActivityData = user[activity.activityId];
      if (userActivityData) {
        csvData.push(
          createCSVRow(user, activity, userActivityData, programName)
        );
      }
    });
  });

  return csvData;
};

export const generateTraineeGradebookCSVData = (activities, programName) => {
  const csvData = [];

  activities.forEach((activity) => {
    csvData.push(createTraineeCSVRow(activity, programName));
  });

  return csvData;
};

export {
  createCSVRow,
  formatAttempts,
  formatScore,
  getActivityStatus,
  getContentTypeLabel,
};
